<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <template v-if="notice">
          <h1 class="text-title-underline">{{ notice.title }}</h1>
          <div>
            <div class="v-html whitespace-pre-wrap mb-6" v-html="notice.body" />
          </div>
        </template>
        <template v-else>
          ページが見つかりませんでした。
        </template>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { axios, ApiResponse } from '@/plugins/axios'
import { NoticeAttributes } from '@/types/models/notice'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth
  },
  setup() {
    const route = useRoute()
    const notice = ref<NoticeAttributes | undefined>()

    onMounted(() => {
      axios
        .get<ApiResponse<NoticeAttributes>>(`/notice/${route.params.notice_id}`)
        .then(response => {
          notice.value = response.data.payload
        })
    })

    return {
      notice
    }
  }
})
</script>
